var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.initialRoute === 'login')?_c('login-view'):_c('main-app')],1)}
var staticRenderFns = []

export { render, staticRenderFns }